import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { Box, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { openModalDelete } from "../../../recoil/modal";
import { dataClickItem, updateDataState } from "../../../recoil/global";
import { DeleteJobs } from "../../../services/api/jobs";
import GeneralModal from "../../GeneralModal/GeneralModal";

export default function ModalDelete() {
  const [open, setOpen] = useRecoilState(openModalDelete);
  const [dataItem, setDataItem] = useRecoilState(dataClickItem);
  const setUpdateData = useSetRecoilState(updateDataState);

  const handleSubmit = (event) => {
    event.preventDefault();
    DeleteJobs(dataItem?.id)
      .then((res) => {
        console.log(res);
        toast.success(res?.message);
        handleClose();
        setUpdateData(Math.random());
      })
      .catch((err) => {
        toast.error(<div>{err.response?.data?.errors[0]}</div>);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    setDataItem(null);
  }, [open]);

  return (
    <GeneralModal open={open} onSubmit={handleSubmit}>
      <Box sx={{ mx: 2, my: 1 }}>
        <Typography variant="h2" fontSize={18} fontWeight={400}>
          Do you want to delete {dataItem?.description?.slice(0, 20)}?
        </Typography>
      </Box>
    </GeneralModal>
  );
}
